import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../theme';
import { mediaQuery } from './util/style';

const ButtonWrapper = styled.div`
  display: flex;
  margin: ${appTheme.spacing.default} '0';
  margin-left: ${props => (props.marginLeft ? appTheme.spacing.default : '0')};

  > button {
    width: ${em(appTheme.sizing.buttonWidth)};
  }

  &.full-width {
    > button {
      width: auto;
    }
  }

  ${mediaQuery.xsmall`
    justify-content: center;
    margin-left: 0;
  `};
`;

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/ButtonWrapper.js